import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
export const AlignCenterIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "AlignCenter",
    children: /*#__PURE__*/_jsx("path", {
      d: "M3.62 6.31h24.77c.89 0 1.62-.72 1.62-1.62s-.72-1.62-1.62-1.62H3.62C2.73 3.07 2 3.79 2 4.69s.72 1.62 1.62 1.62M10.09 10.62c-.89 0-1.62.72-1.62 1.62s.72 1.62 1.62 1.62h11.85c.89 0 1.62-.72 1.62-1.62s-.72-1.62-1.62-1.62zM28.38 18.15H3.62c-.89 0-1.62.72-1.62 1.62s.72 1.62 1.62 1.62h24.77c.89 0 1.62-.72 1.62-1.62s-.72-1.62-1.62-1.62ZM21.93 25.69H10.08c-.89 0-1.62.72-1.62 1.62s.72 1.62 1.62 1.62h11.85c.89 0 1.62-.72 1.62-1.62s-.72-1.62-1.62-1.62"
    })
  }));
};